import axios from 'axios';

export const FILE_URL = `${process.env.REACT_APP_FILE_URL}`;
const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN;
const REACT_APP_DOMAIN_LOCAL = process.env.REACT_APP_API_URL;
const REACT_APP_VERSION_START = process.env.REACT_APP_VERSION_START;
const regexUrl = /^(([0-9]{1,3}\.){3}[0-9]{1,3})(:[0-9]{1,5})?/;

function hasIP(url) {
  return regexUrl.test(url);
}
const GetAPI = () => {
  let hostname = window.location.hostname;
  const referer = window.document.referrer;
  if (referer) {
    const regex = /^https?:\/\//i;
    hostname = referer.replace(regex, '');
  }

  if (hostname?.includes('localhost')) {
    return REACT_APP_DOMAIN_LOCAL;
  } else {
    if (hasIP(hostname)) {
      const apiUrl = 'http://root' + REACT_APP_DOMAIN;
      return apiUrl;
    }
    const hostnameArr = hostname.split('.');
    const apiUrl = 'http://' + hostnameArr[0] + REACT_APP_DOMAIN;
    return apiUrl;
  }
};
export const API_URL = REACT_APP_VERSION_START == 'dev' ? GetAPI() : '';

export const requestGET = async (URL) => {
  try {
    const res = await axios({
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      url: `${API_URL}/${URL}`,
    });
    return res.data;
  } catch (error) {
    return null;
  }
};

export const requestPOST = async (URL, data) => {
  try {
    const res = await axios({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      url: `${API_URL}/${URL}`,
      data,
    });

    return res.data;
  } catch (error) {
    return null;
  }
};
export const requestPOSTRoot = async (URL, data) => {
  try {
    const res = await axios({
      method: 'POST',
      headers: {
        tenant: 'root',
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      url: `${API_URL}/${URL}`,
      data,
    });

    return res.data;
  } catch (error) {
    return null;
  }
};

export const requestPOST_NEW = async (URL, data) => {
  try {
    const res = await axios({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      url: `${API_URL}/${URL}`,
      data,
    });

    return res;
  } catch (error) {
    return error?.response ?? null;
  }
};

export const requestPUT_NEW = async (URL, data) => {
  try {
    const res = await axios({
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      url: `${API_URL}/${URL}`,
      data,
    });

    return res;
  } catch (error) {
    return error?.response ?? null;
  }
};

export const requestDOWNLOADFILE = async (URL, data) => {
  try {
    const res = await axios({
      method: 'POST',
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
      },
      url: `${API_URL}/${URL}`,
      data,
    });

    return res;
  } catch (error) {
    return null;
  }
};

export const requestPUT = async (URL, data) => {
  try {
    const res = await axios({
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      url: `${API_URL}/${URL}`,
      data,
    });

    return res.data;
  } catch (error) {
    return null;
  }
};

export const requestDELETE = async (URL) => {
  try {
    const res = await axios({
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      url: `${API_URL}/${URL}`,
    });

    return res.data;
  } catch (error) {
    return null;
  }
};
